/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Mathematics18Inputs */

const en__field_enum_subject_mathematics18 = /** @type {(inputs: _Field_Enum_Subject_Mathematics18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematics`)
};

const de__field_enum_subject_mathematics18 = /** @type {(inputs: _Field_Enum_Subject_Mathematics18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematik`)
};

/**
* | output |
* | --- |
* | "Mathematics" |
*
* @param {_Field_Enum_Subject_Mathematics18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_mathematics18 = /** @type {((inputs?: _Field_Enum_Subject_Mathematics18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Mathematics18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_mathematics18(inputs)
	return de__field_enum_subject_mathematics18(inputs)
});
export { _field_enum_subject_mathematics18 as "_field_enum_SUBJECT_MATHEMATICS" }